<form [formGroup]="formParametroPeriodo" (submit)="onSalvar()">
    <!-- Breadcrumb -->
    <breadcrumb [paginas]="[
      {route:'/home',name:'Home'},
      {route:'/parametros-periodo',name:'Configuração de vigências'}
    ]" />

    <!-- TÍTULO -->
    <section class="section-saudacao">
        <div class="container">
            <h2 class="titulo-page">Configuração de vigências</h2>
            <p class="descricao-page">Defina as datas para o envio dos Planos de Contingência e Planos de Melhoria de Convivência.</p>
        </div>
    </section>

    <!-- CONTEÚDO PRINCIPAL -->
    <section class="conteudo-principal">
        <div class="container-conviva">
            <!-- Faixa vermelha do topo -->
            <div class="time-line mx-w-900">
                <!-- Área de filtros -->
                <div class="section-filtro">
                    <div class="container">

                        <!-- PLANO -->
                        <div class="grupo-filter-full">
                            <label for="codigoPlano">Plano vinculado</label>
                            <ng-select [items]="planos" bindLabel="descricaoPlano" bindValue="codigoPlano"
                                placeholder="Selecione um Plano" formControlName="codigoPlano" name="codigoPlano"
                                [ngClass]="{ 'is-invalid': submitted && formParametroPeriodo.get('codigoPlano')?.errors }"
                                aria-describedby="plano-error">
                            </ng-select>
                            <div *ngIf="submitted && formParametroPeriodo.get('codigoPlano')?.errors"
                                class="alert alert-danger">
                                <div *ngIf="formParametroPeriodo.get('codigoPlano')?.errors?.['required']">
                                    * Plano é obrigatório
                                </div>
                            </div>
                        </div>

                        <!-- DATA DE INÍCIO -->
                        <div class="grupo-filter-full">
                            <label for="dataInicio">Data de início</label>
                            <input type="date" id="dataInicio" name="dataInicio" formControlName="dataInicio"
                                class="input-date"
                                [ngClass]="{ 'is-invalid': submitted && formParametroPeriodo.get('dataInicio')?.errors }"
                                aria-describedby="data-inicio-error" />
                            <div *ngIf="submitted && formParametroPeriodo.get('dataInicio')?.errors"
                                class="alert alert-danger">
                                <div *ngIf="formParametroPeriodo.get('dataInicio')?.errors?.['required']">
                                    * Data de início é obrigatória
                                </div>
                                <div *ngIf="formParametroPeriodo.get('dataInicio')?.errors?.['dataInvalida']">
                                    * Data de início inválida
                                </div>
                            </div>
                        </div>

                        <!-- DATA DE TÉRMINO -->
                        <div class="grupo-filter-full">
                            <label for="dataFim">Data de término</label>
                            <input type="date" id="dataFim" name="dataFim" formControlName="dataFim" class="input-date"
                                [ngClass]="{ 'is-invalid': submitted && formParametroPeriodo.get('dataFim')?.errors }"
                                aria-describedby="data-fim-error" />
                            <div *ngIf="submitted && formParametroPeriodo.get('dataFim')?.errors"
                                class="alert alert-danger">
                                <div *ngIf="formParametroPeriodo.get('dataFim')?.errors?.['required']">
                                    * Data de término é obrigatória
                                </div>
                                <div *ngIf="formParametroPeriodo.get('dataFim')?.errors?.['dataInvalida']">
                                    * Data de término inválida
                                </div>
                                <div *ngIf="formParametroPeriodo.get('dataFim')?.errors?.['dataFimAnteriorInicio']">
                                    * Data de término não pode ser anterior à data de início
                                </div>
                            </div>
                        </div>

                        <div class="container-btns">
                            <input type="button" class="btn_outline" id="btnLimpar" name="btnLimpar" value="Limpar"
                                aria-label="Limpar" (click)="onLimpar()" *ngIf="!editando" />

                            <input type="button" class="btn_outline" id="btnCancelar" name="btnCancelar"
                                value="Cancelar" aria-label="Cancelar" (click)="onCancelar()" *ngIf="editando" />

                            <input type="submit" class="btn_primary" [value]="editando ? 'Salvar alterações' : 'Salvar'" aria-label="Salvar" />
                        </div>
                    </div>
                </div>
                <br /><br />
                <!-- GRID -->
                <section class="section-grid-consulta-ponto">
                    <div class="container">
                        <div class="row_registros">
                            <h3>Lista Parametros Períodos</h3>
                        </div>
                        <div class="grid-datatable">
                            <app-tabulator-table
                            [columnNames]="colunasGrid"
                            [tipoRelatorio]="2"
                            [tableData]="parametrosPeriodo"
                            [mostrarFiltro]="false"
                            [mostrarImprimir]="false"
                            [mostrarExportarHtml]="false"
                            [mostrarExportarExcel]="false"
                            [mostrarExportarPDF]="false"
                            [orientacaoPortrait]="false">>
                            </app-tabulator-table>
                        </div>
                    </div>
                </section>

            </div>
        </div>
    </section>
</form>

<!-- Modal Confirmar Exclusão -->
<app-modal *ngIf="showModalExcluir">
  <div class="container-conviva form-registro modal-envolvidos">
    <p style="margin: 20px 0; font-size: 1.5rem; text-align: center;">
      Tem certeza que deseja excluir este parâmetro de período?
    </p>
    <div class="container-btns" style="justify-content: center; gap: 15px;">
      <input type="button" class="btn_primary" value="Sim" (click)="confirmarExclusao()" />
      <input type="button" class="btn_outline" value="Não" (click)="fecharModalExcluir()" />
    </div>
  </div>
</app-modal>
